import React, { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./vendor-detail.scss";

const vendorRecords = {
  "hikari-house": {
    name: "Hikari House",
    contact: "012-3456789",
    email: "hello@hikarihouse.my",
    city: "Kuching",
    address: "Lot 12, Kuching Central, Jalan Datuk Tawi Sli",
    pic: "Channie Tan",
    status: "Active",
    productStatus: "1 active",
    ordersToday: "12",
    salesToday: "226.80",
    paidOrders: "10",
    pendingOrders: "2",
    soldToday: "7",
    joinedDate: "12 Jun 2026",
    bank: "Maybank •••• 2188",
    bankName: "Maybank",
    bankReceiverName: "Hikari House Sdn Bhd",
    bankAccountNumber: "51422188",
    outlet: {
      name: "Kuching Central",
      city: "Kuching",
      state: "Sarawak",
      postcode: "93300",
      address: "Lot 12, Kuching Central, Jalan Datuk Tawi Sli",
      latitude: "1.5533",
      longitude: "110.3592",
      googleMapUrl: "https://maps.google.com/?q=1.5533,110.3592",
      phone: "012-3456789",
      openTime: "10:00 AM",
      closeTime: "8:00 PM",
      lastOrderTime: "7:30 PM",
      dailyResetTime: "12:00 AM",
      acceptingOrders: "Yes",
      status: "Accepting Orders",
    },
    product: {
      name: "Chicken Katsu Bento",
      description: "Japanese chicken katsu bento with rice and side dish.",
      price: "12.90",
      prepTime: "15",
      image: "",
      dailyQuantity: "18",
      dailySold: "7",
      status: "Available",
    },
  },
  "green-bowl": {
    name: "Green Bowl",
    contact: "011-2233445",
    email: "orders@greenbowl.my",
    city: "Kuching",
    address: "Ground Floor, Jalan Padungan, Kuching",
    pic: "Daniel Lim",
    status: "Active",
    productStatus: "1 active",
    ordersToday: "8",
    salesToday: "92.00",
    paidOrders: "7",
    pendingOrders: "1",
    soldToday: "5",
    joinedDate: "14 Jun 2026",
    bank: "CIMB •••• 7930",
    bankName: "CIMB",
    bankReceiverName: "Green Bowl Enterprise",
    bankAccountNumber: "80187930",
    outlet: {
      name: "Padungan",
      city: "Kuching",
      state: "Sarawak",
      postcode: "93100",
      address: "Ground Floor, Jalan Padungan, Kuching",
      latitude: "1.5580",
      longitude: "110.3518",
      googleMapUrl: "https://maps.google.com/?q=1.5580,110.3518",
      phone: "011-2233445",
      openTime: "10:30 AM",
      closeTime: "7:00 PM",
      lastOrderTime: "6:30 PM",
      dailyResetTime: "12:00 AM",
      acceptingOrders: "Yes",
      status: "Accepting Orders",
    },
    product: {
      name: "Healthy Rice Bowl",
      description: "Balanced rice bowl with vegetables and protein.",
      price: "11.50",
      prepTime: "12",
      image: "",
      dailyQuantity: "15",
      dailySold: "5",
      status: "Available",
    },
  },
  "daily-bakery": {
    name: "Daily Bakery",
    contact: "016-9988776",
    email: "dailybakery@example.com",
    city: "Miri",
    address: "Lot 88, Miri Times Square",
    pic: "Mei Ling",
    status: "Pending Setup",
    productStatus: "No product",
    ordersToday: "0",
    salesToday: "0.00",
    paidOrders: "0",
    pendingOrders: "0",
    soldToday: "0",
    joinedDate: "20 Jun 2026",
    bank: "Pending setup",
    bankName: "",
    bankReceiverName: "",
    bankAccountNumber: "",
    outlet: {
      name: "No outlet yet",
      city: "-",
      state: "Sarawak",
      postcode: "",
      address: "",
      latitude: "",
      longitude: "",
      googleMapUrl: "",
      phone: "016-9988776",
      openTime: "",
      closeTime: "",
      lastOrderTime: "",
      dailyResetTime: "12:00 AM",
      acceptingOrders: "No",
      status: "Pending Setup",
    },
    product: {
      name: "No product yet",
      description: "",
      price: "",
      prepTime: "",
      image: "",
      dailyQuantity: "",
      dailySold: "0",
      status: "Draft",
    },
  },
  "urban-cafe": {
    name: "Urban Cafe",
    contact: "019-7788990",
    email: "urban@example.com",
    city: "Sibu",
    address: "No. 18, Sibu Town Square",
    pic: "Alex Wong",
    status: "Inactive",
    productStatus: "1 inactive",
    ordersToday: "0",
    salesToday: "0.00",
    paidOrders: "0",
    pendingOrders: "0",
    soldToday: "0",
    joinedDate: "18 Jun 2026",
    bank: "Public Bank •••• 6621",
    bankName: "Public Bank",
    bankReceiverName: "Urban Cafe",
    bankAccountNumber: "30626621",
    outlet: {
      name: "Sibu Town Square",
      city: "Sibu",
      state: "Sarawak",
      postcode: "96000",
      address: "No. 18, Sibu Town Square",
      latitude: "2.2873",
      longitude: "111.8305",
      googleMapUrl: "https://maps.google.com/?q=2.2873,111.8305",
      phone: "019-7788990",
      openTime: "10:00 AM",
      closeTime: "6:00 PM",
      lastOrderTime: "5:30 PM",
      dailyResetTime: "12:00 AM",
      acceptingOrders: "No",
      status: "Inactive",
    },
    product: {
      name: "Americano Combo",
      description: "Coffee combo for pickup.",
      price: "9.90",
      prepTime: "8",
      image: "",
      dailyQuantity: "0",
      dailySold: "0",
      status: "Hidden",
    },
  },
};

const defaultVendor = {
  name: "",
  contact: "",
  email: "",
  city: "Kuching",
  address: "",
  pic: "",
  status: "Pending Setup",
  productStatus: "No product",
  ordersToday: "0",
  salesToday: "0.00",
  paidOrders: "0",
  pendingOrders: "0",
  soldToday: "0",
  joinedDate: "28 Jun 2026",
  bank: "",
  bankName: "",
  bankReceiverName: "",
  bankAccountNumber: "",
  outlet: {
    name: "No outlet yet",
    city: "-",
    state: "Sarawak",
    postcode: "",
    address: "",
    latitude: "",
    longitude: "",
    phone: "",
    openTime: "",
    closeTime: "",
    lastOrderTime: "",
    acceptingOrders: "No",
    status: "Pending Setup",
  },
  product: {
    name: "No product yet",
    description: "",
    price: "",
    prepTime: "",
    image: "",
    dailyQuantity: "",
      dailySold: "0",
    status: "Draft",
  },
};

const statusClass = (value) => String(value).toLowerCase().replace(/\s+/g, "-");
const slugify = (value) => String(value).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
const formatPrice = (value) => (value && value !== "-" ? `RM${Number(value).toFixed(2)}` : "-");
const formatBankAccount = (bankName, accountNumber) => {
  if (!bankName && !accountNumber) return "Pending setup";
  if (!accountNumber) return bankName || "Pending setup";
  const digits = String(accountNumber).replace(/\s+/g, "");
  const lastFour = digits.slice(-4);
  return `${bankName || "Bank"} •••• ${lastFour}`;
};
const timeToInput = (value) => {
  if (!value) return "";
  const match = String(value).trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)?$/i);
  if (!match) return value;
  let hour = Number(match[1]);
  const minute = match[2];
  const period = match[3]?.toUpperCase();
  if (period === "PM" && hour < 12) hour += 12;
  if (period === "AM" && hour === 12) hour = 0;
  return `${String(hour).padStart(2, "0")}:${minute}`;
};
const inputToTime = (value) => {
  if (!value) return "";
  const [hourText, minute] = value.split(":");
  let hour = Number(hourText);
  const period = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12;
  return `${hour}:${minute} ${period}`;
};

const INVENTORY_RULES = {
  resetAutomatically: true,
  reduceQuantityOn: ["On Hold", "On Paid"],
  restoreQuantityOn: ["Cancelled", "Payment Timeout"],
};


const InfoItem = ({ label, value }) => (
  <div className="vendor-detail__info-item">
    <span>{label}</span>
    <strong>{value || "-"}</strong>
  </div>
);

const TextField = ({ label, value, onChange, placeholder, type = "text", readOnly = false, helpText }) => (
  <label className={`vendor-detail__field${readOnly ? " vendor-detail__field--readonly" : ""}`}>
    <span>{label}</span>
    <input
      type={type}
      value={value || ""}
      placeholder={placeholder}
      readOnly={readOnly}
      aria-readonly={readOnly}
      onChange={(event) => !readOnly && onChange?.(event.target.value)}
    />
    {helpText && <small>{helpText}</small>}
  </label>
);

const ImageUploadField = ({ label, value, onChange }) => {
  const hasPreview = value && String(value).startsWith("blob:");

  return (
    <label className="vendor-detail__field vendor-detail__field--upload">
      <span>{label}</span>
      <input
        type="file"
        accept="image/png,image/jpeg,image/webp"
        onChange={(event) => {
          const file = event.target.files?.[0];
          if (!file) return;
          onChange({ fileName: file.name, previewUrl: URL.createObjectURL(file) });
        }}
      />
      <div className="vendor-detail__upload-box">
        {hasPreview ? <img src={value} alt="Product preview" /> : <strong>{value || "Choose product image"}</strong>}
        <small>PNG, JPG, or WebP. The API upload can be connected later.</small>
      </div>
    </label>
  );
};

const TimeField = ({ label, value, onChange }) => (
  <label className="vendor-detail__field">
    <span>{label}</span>
    <input type="time" value={timeToInput(value)} onChange={(event) => onChange(inputToTime(event.target.value))} />
  </label>
);

const Modal = ({ title, description, children, onClose, onSave, saveLabel = "Save" }) => (
  <div className="vendor-detail__modal-backdrop" role="presentation">
    <div className="vendor-detail__modal" role="dialog" aria-modal="true" aria-label={title}>
      <div className="vendor-detail__modal-header">
        <div>
          <h3>{title}</h3>
          {description && <p>{description}</p>}
        </div>
        <button type="button" onClick={onClose}>×</button>
      </div>
      <div className="vendor-detail__modal-body">{children}</div>
      <div className="vendor-detail__modal-footer">
        <button className="vendor-detail__secondary-btn" type="button" onClick={onClose}>Cancel</button>
        <button className="vendor-detail__primary-btn" type="button" onClick={onSave}>{saveLabel}</button>
      </div>
    </div>
  </div>
);

const VendorDetailPage = ({ mode = "view" }) => {
  const navigate = useNavigate();
  const { vendorId } = useParams();
  const isCreate = mode === "create" || vendorId === "create";
  const isEdit = mode === "edit" || isCreate;

  const sourceVendor = useMemo(() => {
    if (isCreate) return defaultVendor;
    return vendorRecords[vendorId] || vendorRecords["hikari-house"];
  }, [isCreate, vendorId]);

  const [vendor, setVendor] = useState(sourceVendor);
  const [draftOutlet, setDraftOutlet] = useState(sourceVendor.outlet);
  const [draftProduct, setDraftProduct] = useState(sourceVendor.product);
  const [activeModal, setActiveModal] = useState(null);
  const [message, setMessage] = useState("");

  const updateVendor = (field, value) => setVendor((current) => {
    const next = { ...current, [field]: value };
    if (["bankName", "bankAccountNumber"].includes(field)) {
      next.bank = formatBankAccount(next.bankName, next.bankAccountNumber);
    }
    return next;
  });
  const updateOutlet = (field, value) => setDraftOutlet((current) => ({ ...current, [field]: value }));
  const updateProduct = (field, value) => setDraftProduct((current) => ({ ...current, [field]: value }));

  const openOutletModal = () => {
    setDraftOutlet(vendor.outlet);
    setActiveModal("outlet");
  };

  const openProductModal = () => {
    setDraftProduct(vendor.product);
    setActiveModal("product");
  };

  const handleSave = () => {
    setMessage(isCreate ? "Vendor created successfully. API connection can be added later." : "Vendor details saved. API connection can be added later.");
    if (isCreate && vendor.name) navigate(`/admin/vendors/${slugify(vendor.name)}`, { replace: true });
  };

  const saveOutlet = () => {
    setVendor((current) => ({
      ...current,
      city: draftOutlet.city && draftOutlet.city !== "-" ? draftOutlet.city : current.city,
      outlet: draftOutlet,
    }));
    setActiveModal(null);
    setMessage("Outlet setup saved. MVP allows one outlet per merchant only.");
  };

  const saveProduct = () => {
    const hasProduct = draftProduct.name && draftProduct.name !== "No product yet";
    setVendor((current) => ({
      ...current,
      product: draftProduct,
      productStatus: hasProduct ? (draftProduct.status === "Available" ? "1 active" : "1 inactive") : "No product",
    }));
    setActiveModal(null);
    setMessage("Product setup saved. MVP allows one product per merchant only.");
  };

  const handleSendSetupEmail = () => {
    setMessage(`Welcome email prepared for ${vendor.email || "this vendor"}. It contains the portal link, login email, temporary password, and setup steps.`);
  };

  const handleDeactivate = () => {
    setVendor((current) => ({ ...current, status: current.status === "Inactive" ? "Active" : "Inactive" }));
    setMessage(vendor.status === "Inactive" ? "Vendor reactivated." : "Vendor deactivated. Order history is preserved.");
  };

  return (
    <div className="vendor-detail">
      <section className="vendor-detail__header">
        <div>
          <button className="vendor-detail__back" type="button" onClick={() => navigate("/admin/vendors")}>← Back to Vendors</button>
          <p className="vendor-detail__eyebrow">SecondBite Admin</p>
          <h2>{isCreate ? "Create Vendor" : vendor.name}</h2>
          <p>{isCreate ? "Add a new vendor profile with one outlet setup and single product setup readiness." : "Review vendor profile, single outlet setup, single product setup, and order activity."}</p>
        </div>

        <div className="vendor-detail__header-actions">
          {!isCreate && <span className={`vendor-detail__status vendor-detail__status--${statusClass(vendor.status)}`}>{vendor.status}</span>}
          {!isEdit && <button type="button" onClick={() => navigate(`/admin/vendors/${vendorId}/edit`)}>Edit Vendor</button>}
          {isEdit && <button type="button" onClick={handleSave}>Save Vendor</button>}
        </div>
      </section>

      {message && <div className="vendor-detail__notice">{message}</div>}

      <section className="vendor-detail__summary-grid">
        <InfoItem label="Contact" value={vendor.contact} />
        <InfoItem label="City / Area" value={vendor.city} />
        <InfoItem label="Product" value={vendor.productStatus} />
        <InfoItem label="Orders Today" value={vendor.ordersToday} />
      </section>

      <section className="vendor-detail__content-grid">
        <div className="vendor-detail__panel vendor-detail__panel--wide">
          <div className="vendor-detail__panel-title">
            <h3>Vendor Profile</h3>
            <p>Static MVP UI sample. Connect API later.</p>
          </div>

          {isEdit ? (
            <div className="vendor-detail__form-grid">
              <TextField label="Vendor Name" value={vendor.name} placeholder="Enter vendor name" onChange={(value) => updateVendor("name", value)} />
              <TextField label="Contact Number" value={vendor.contact} placeholder="012-3456789" onChange={(value) => updateVendor("contact", value)} />
              <TextField label="Email" value={vendor.email} placeholder="vendor@example.com" onChange={(value) => updateVendor("email", value)} />
              <TextField label="Person In Charge" value={vendor.pic} placeholder="PIC name" onChange={(value) => updateVendor("pic", value)} />
              <TextField label="Bank Name" value={vendor.bankName} placeholder="Maybank" onChange={(value) => updateVendor("bankName", value)} />
              <TextField label="Bank Receiver Name" value={vendor.bankReceiverName} placeholder="Account holder name" onChange={(value) => updateVendor("bankReceiverName", value)} />
              <TextField label="Bank Account Number" value={vendor.bankAccountNumber} placeholder="51422188" onChange={(value) => updateVendor("bankAccountNumber", value)} />
              <label className="vendor-detail__field">
                <span>Status</span>
                <select value={vendor.status} onChange={(event) => updateVendor("status", event.target.value)}>
                  <option>Active</option>
                  <option>Inactive</option>
                  <option>Pending Setup</option>
                </select>
              </label>
              <label className="vendor-detail__field vendor-detail__field--full">
                <span>Address</span>
                <textarea value={vendor.address} placeholder="Vendor address" onChange={(event) => updateVendor("address", event.target.value)} />
              </label>
            </div>
          ) : (
            <div className="vendor-detail__profile-grid">
              <InfoItem label="Vendor Name" value={vendor.name} />
              <InfoItem label="Person In Charge" value={vendor.pic} />
              <InfoItem label="Email" value={vendor.email} />
              <InfoItem label="Joined Date" value={vendor.joinedDate} />
              <InfoItem label="Address" value={vendor.address} />
              <InfoItem label="Bank Name" value={vendor.bankName} />
              <InfoItem label="Receiver Name" value={vendor.bankReceiverName} />
              <InfoItem label="Account Number" value={vendor.bankAccountNumber} />
            </div>
          )}
        </div>

        <div className="vendor-detail__panel">
          <div className="vendor-detail__panel-title">
            <h3>Quick Actions</h3>
          </div>
          <button className="vendor-detail__action vendor-detail__action--muted" type="button" onClick={openOutletModal}>Edit Outlet Setup</button>
          <button className="vendor-detail__action" type="button" onClick={openProductModal}>Edit Product Setup</button>
          <button className="vendor-detail__action vendor-detail__action--muted" type="button" onClick={handleSendSetupEmail}>Resend Welcome Email</button>
          {!isCreate && (
            <button className="vendor-detail__action vendor-detail__action--danger" type="button" onClick={handleDeactivate}>
              {vendor.status === "Inactive" ? "Reactivate Vendor" : "Deactivate Vendor"}
            </button>
          )}
        </div>

        <div className="vendor-detail__panel vendor-detail__panel--wide">
          <div className="vendor-detail__panel-title">
            <h3>Sales Summary</h3>
            <p>Today's MVP sales snapshot.</p>
          </div>
          <div className="vendor-detail__sales-grid">
            <InfoItem label="Sales Today" value={formatPrice(vendor.salesToday)} />
            <InfoItem label="Orders Today" value={vendor.ordersToday} />
            <InfoItem label="Paid Orders" value={vendor.paidOrders} />
            <InfoItem label="Pending Orders" value={vendor.pendingOrders} />
            <InfoItem label="Daily Quantity" value={vendor.product.dailyQuantity || "-"} />
            <InfoItem label="Daily Sold" value={vendor.product.dailySold || vendor.soldToday || "0"} />
            <InfoItem label="Daily Reset Time" value={vendor.outlet.dailyResetTime || "12:00 AM"} />
          </div>
        </div>

        <div className="vendor-detail__panel vendor-detail__panel--wide">
          <div className="vendor-detail__panel-title">
            <h3>Outlet Setup</h3>
            <p>MVP limit: one vendor can manage one outlet only.</p>
          </div>
          <div className="vendor-detail__table">
            <div className="vendor-detail__table-head vendor-detail__table-head--outlets">
              <span>Outlet</span><span>City</span><span>Operating Hours</span><span>Daily Reset</span><span>Google Map</span><span>Status</span>
            </div>
            <div className="vendor-detail__table-row vendor-detail__table-row--outlets">
              <span>{vendor.outlet.name || "No outlet yet"}</span>
              <span>{vendor.outlet.city || "-"}</span>
              <span>{vendor.outlet.openTime && vendor.outlet.closeTime ? `${vendor.outlet.openTime} - ${vendor.outlet.closeTime}` : "-"}</span>
              <span>{vendor.outlet.dailyResetTime || "12:00 AM"}</span>
              <span>{vendor.outlet.googleMapUrl ? <a href={vendor.outlet.googleMapUrl} target="_blank" rel="noreferrer">Open Map</a> : "-"}</span>
              <span className={`vendor-detail__status vendor-detail__status--${statusClass(vendor.outlet.status)}`}>{vendor.outlet.status}</span>
            </div>
          </div>
        </div>

        <div className="vendor-detail__panel vendor-detail__panel--wide">
          <div className="vendor-detail__panel-title">
            <h3>Product Setup</h3>
            <p>MVP limit: one merchant can manage one product only.</p>
          </div>
          <div className="vendor-detail__table">
            <div className="vendor-detail__table-head vendor-detail__table-head--listings">
              <span>Product</span><span>Price</span><span>Daily Qty</span><span>Daily Sold</span><span>Status</span>
            </div>
            <div className="vendor-detail__table-row vendor-detail__table-row--listings">
              <span>{vendor.product.name || "No product yet"}</span>
              <span>{formatPrice(vendor.product.price)}</span>
              <span>{vendor.product.dailyQuantity || "-"}</span>
              <span>{vendor.product.dailySold || vendor.soldToday || "0"}</span>
              <span className={`vendor-detail__status vendor-detail__status--${statusClass(vendor.product.status)}`}>{vendor.product.status}</span>
            </div>
          </div>
        </div>
      </section>

      {activeModal === "outlet" && (
        <Modal title="Edit Outlet Setup" description="MVP supports one outlet only for each merchant." onClose={() => setActiveModal(null)} onSave={saveOutlet} saveLabel="Save Outlet">
          <div className="vendor-detail__form-grid">
            <TextField label="Outlet Name" value={draftOutlet.name} placeholder="Kuching Central" onChange={(value) => updateOutlet("name", value)} />
            <TextField label="Business Phone" value={draftOutlet.phone} placeholder="012-3456789" onChange={(value) => updateOutlet("phone", value)} />
            <TextField label="Address" value={draftOutlet.address} placeholder="Outlet address" onChange={(value) => updateOutlet("address", value)} />
            <TextField label="City" value={draftOutlet.city} placeholder="Kuching" onChange={(value) => updateOutlet("city", value)} />
            <TextField label="State" value={draftOutlet.state} placeholder="Sarawak" onChange={(value) => updateOutlet("state", value)} />
            <TextField label="Postcode" value={draftOutlet.postcode} placeholder="93300" onChange={(value) => updateOutlet("postcode", value)} />
            <TextField label="Latitude" value={draftOutlet.latitude} placeholder="1.5533" onChange={(value) => updateOutlet("latitude", value)} />
            <TextField label="Longitude" value={draftOutlet.longitude} placeholder="110.3592" onChange={(value) => updateOutlet("longitude", value)} />
            <TextField label="Google Map URL" value={draftOutlet.googleMapUrl} placeholder="https://maps.google.com/?q=..." onChange={(value) => updateOutlet("googleMapUrl", value)} />
            <TimeField label="Open Time" value={draftOutlet.openTime} onChange={(value) => updateOutlet("openTime", value)} />
            <TimeField label="Close Time" value={draftOutlet.closeTime} onChange={(value) => updateOutlet("closeTime", value)} />
            <TimeField label="Last Order Time" value={draftOutlet.lastOrderTime} onChange={(value) => updateOutlet("lastOrderTime", value)} />
            <TimeField label="Daily Quantity Reset Time" value={draftOutlet.dailyResetTime || "12:00 AM"} onChange={(value) => updateOutlet("dailyResetTime", value)} />
            <label className="vendor-detail__field">
              <span>Accepting Orders</span>
              <select value={draftOutlet.acceptingOrders} onChange={(event) => updateOutlet("acceptingOrders", event.target.value)}>
                <option>Yes</option>
                <option>No</option>
              </select>
            </label>
            <label className="vendor-detail__field">
              <span>Status</span>
              <select value={draftOutlet.status} onChange={(event) => updateOutlet("status", event.target.value)}>
                <option>Accepting Orders</option>
                <option>Pending Setup</option>
                <option>Inactive</option>
              </select>
            </label>
          </div>
        </Modal>
      )}

      {activeModal === "product" && (
        <Modal title="Edit Product Setup" description="MVP supports one product only for each merchant." onClose={() => setActiveModal(null)} onSave={saveProduct} saveLabel="Save Product">
          <div className="vendor-detail__form-grid">
            <TextField label="Product Name" value={draftProduct.name} placeholder="Chicken Katsu Bento" onChange={(value) => updateProduct("name", value)} />
            <TextField label="Price (RM)" value={draftProduct.price} placeholder="12.90" type="number" onChange={(value) => updateProduct("price", value)} />
            <TextField label="Preparation Time (mins)" value={draftProduct.prepTime} placeholder="15" type="number" onChange={(value) => updateProduct("prepTime", value)} />
            <TextField label="Daily Quantity" value={draftProduct.dailyQuantity} placeholder="18" type="number" onChange={(value) => updateProduct("dailyQuantity", value)} />
            <TextField
              label="Daily Sold"
              value={draftProduct.dailySold}
              placeholder="0"
              type="number"
              readOnly
              helpText="Auto-calculated from today's paid/collected orders."
            />
            <div className="vendor-detail__rule-card vendor-detail__field--full">
              <span>Inventory Rules</span>
              <strong>Program controlled</strong>
              <small>Reset automatically: {INVENTORY_RULES.resetAutomatically ? "Yes" : "No"}</small>
              <small>Reduce quantity: {INVENTORY_RULES.reduceQuantityOn.join(", ")}</small>
              <small>Restore quantity: {INVENTORY_RULES.restoreQuantityOn.join(", ")}</small>
            </div>
            <ImageUploadField
              label="Product Image"
              value={draftProduct.imagePreview || draftProduct.image}
              onChange={({ fileName, previewUrl }) => setDraftProduct((current) => ({ ...current, image: fileName, imagePreview: previewUrl }))}
            />
            <label className="vendor-detail__field">
              <span>Status</span>
              <select value={draftProduct.status} onChange={(event) => updateProduct("status", event.target.value)}>
                <option>Available</option>
                <option>Sold Out</option>
                <option>Hidden</option>
                <option>Draft</option>
              </select>
            </label>
            <label className="vendor-detail__field vendor-detail__field--full">
              <span>Description</span>
              <textarea value={draftProduct.description} placeholder="Describe the product" onChange={(event) => updateProduct("description", event.target.value)} />
            </label>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default VendorDetailPage;
